import cssVariables from 'tfs.css-variables'

export default {
  wrapper: {
    position: 'fixed',
    zIndex: 90,
    backgroundColor: cssVariables.colorWhite,
    width: '100%',
    height: '6rem',
    bottom: 0,
    left: 0,
    boxShadow: '0 -0.05rem 0.5rem 0 rgba(0,0,0,0.1)',
    transition: 'visibility 1s, transform 0.35s ease',
  },
  hidden: {
    transform: 'translateY(6rem)',
    visibility: 'hidden',
  },
  verticalContent: {
    display: 'flex',
    height: '100%',
    margin: '0 3.5rem',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  alignItemsRight: {
    justifyContent: 'flex-end',
  },
}
